import PropTypes from 'prop-types';


class Modal extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    confirmButtonText: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    body: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    loadingText: PropTypes.string,
    id: PropTypes.string,
    onOpen: PropTypes.func,
    cancelButtonText: PropTypes.string,
    isDangerous: PropTypes.bool,
    large: PropTypes.bool,
    isInfoModal: PropTypes.bool,
  };

  static defaultProps = {
    id: 'modal',
    cancelButtonText: 'Cancel',
    isDangerous: false,
    isLoading: false,
    loadingText: 'Loading...',
    large: false,
    isInfoModal: false,
    onOpen: () => {},
  };

  constructor (props, context) {
    super(props, context);
    this.state.cancelButtonText = props.cancelButtonText;
    this.state.title = props.title;
    this.state.confirmButtonText = props.confirmButtonText;
    this.state.body = props.body;
    this.state.isDangerous = props.isDangerous;
    this.state.onConfirm = props.onConfirm;
    this.state.onOpen = props.onOpen;
    this.state.isLoading = props.isLoading;
    this.state.loadingText = props.loadingText;
    this.state.large = props.large;
    this.state.isInfoModal = props.isInfoModal;
  }

  state = {
    cancelButtonText: 'Cancel',
    isDangerous: false,
    trigger: null,
  };

  componentDidMount () {
    // https://getbootstrap.com/docs/4.1/components/modal/#events
    $(`#${this.props.id}`).on('show.bs.modal', e => {
      this.state.onOpen(e, this);
      this.setState({trigger: e.relatedTarget || {}});
    });
  }

  getModalBody () {
    if (this.state.isDangerous) {
      // eslint-disable-next-line react/no-danger
      return <div dangerouslySetInnerHTML={{__html: this.state.body}} />;
    }
    return this.state.body;
  }

  getCancelButton () {
    if (this.state.isInfoModal) {
      return '';
    }

    return (
      <button type="button" className="btn btn-link" data-dismiss="modal">
        {this.state.cancelButtonText}
      </button>
    );
  }

  loading () {
    if (this.state.isLoading) {
      return (
        <div className="text-center">
          <p className="mb-1">{this.state.loadingText}</p>
          <i className="fa fa-spin fa-circle-o-notch" />
        </div>
      );
    }
    return '';
  }

  render () {
    return (
      <div className="modal fade" tabIndex="-1" id={this.props.id} role="dialog">
        <div className={`modal-dialog ${this.state.large ? 'modal-lg' : ''}`}>
          <div className="card modal-content">
            <div className="card-header modal-header">
              <h4 className="modal-title h5">
                {this.state.title}
              </h4>
            </div>
            <div className="modal-body">
              {this.loading()}
              {this.getModalBody()}
            </div>
            <div className="modal-footer">
              {this.getCancelButton()}
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={e => {this.state.onConfirm(e, this.state.trigger.dataset);}}
              >
                {this.state.confirmButtonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function initialiseModal (props) {
  let component;
  ReactDOM.render(
    <Modal {...props} ref={c => {component = c;}} />,
    document.querySelector('#modal-container'),
  );

  return component;
}


export {initialiseModal, Modal};
